/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportData } from './reportData';


export interface MonitoringReportResponseDTO { 
    report_id?: string;
    serialnumber?: string;
    start?: string;
    stop?: string;
    status?: string;
    licenceFlag?: boolean;
    data?: ReportData;
    timezone?: string;
    manufacturer?: string;
    yearOfManufacture?: string;
    machineDisplayName?: string;
    machineType?: MonitoringReportResponseDTO.MachineTypeEnum;
}
export namespace MonitoringReportResponseDTO {
    export const MachineTypeEnum = {
        IntegratedDirectDriveSeparator: 'INTEGRATED_DIRECT_DRIVE_SEPARATOR',
        Decanter: 'DECANTER',
        DirectDriveSeparator: 'DIRECT_DRIVE_SEPARATOR',
        FlatBeltSeparator: 'FLAT_BELT_SEPARATOR',
        GearboxSeparator: 'GEARBOX_SEPARATOR',
        CodestrykeSystems: 'CODESTRYKE_SYSTEMS'
    } as const;
    export type MachineTypeEnum = typeof MachineTypeEnum[keyof typeof MachineTypeEnum];
}


